import React from "react";

function ReserveButton({ onClick, disabled, reserveBtnRef, label }) {
  return (
    <button
      ref={reserveBtnRef}
      className="reserve-button"
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

export default ReserveButton;